import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class DefaultLayoutView extends Component {

  render() {
    const { user, errorMessage } = this.props;

    return (
      <div className="default-layout">
        {errorMessage ? (
          <div className="errorMessage">{errorMessage}</div>
        ) : null}
        <div className="default-layout-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default DefaultLayoutView;



// WEBPACK FOOTER //
// ./src/app/layouts/default/DefaultLayoutView.js